import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("vmffm_cookie_consent")) setVisible(true);
  }, []);
  const decide = (val) => {
    localStorage.setItem("vmffm_cookie_consent", val);
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-[60] bg-navy-800 border border-gold-500/30 rounded-md p-6 shadow-2xl">
      <h4 className="font-heading font-bold text-white text-lg mb-2">Datenschutz-Einstellungen</h4>
      <p className="text-sm text-slate-300 leading-relaxed mb-4">
        Wir verwenden Cookies, um unsere Website optimal zu gestalten. Details in unserer{" "}
        <Link to="/datenschutz" className="text-gold-500 underline">Datenschutzerklärung</Link>.
      </p>
      <div className="flex gap-3">
        <button data-testid="cookie-accept" onClick={() => decide("all")} className="flex-1 bg-gold-500 text-navy-900 font-bold rounded-sm py-2.5 text-sm hover:bg-gold-300 transition-colors">Alle akzeptieren</button>
        <button data-testid="cookie-essential" onClick={() => decide("essential")} className="flex-1 border border-white/20 text-white rounded-sm py-2.5 text-sm hover:border-gold-500 transition-colors">Nur notwendige</button>
      </div>
    </div>
  );
}
